import { computed, toValue, type MaybeRefOrGetter } from 'vue';

type FieldErrorText = string;
type FieldErrors = FieldErrorText | FieldErrorText[] | undefined | null;

const useFieldErrors = (errors: MaybeRefOrGetter<FieldErrors>) => {
  const errorsToShow = computed<FieldErrorText[]>(() => {
    const _errors = toValue(errors);

    if (Array.isArray(_errors)) {
      return _errors;
    }

    return _errors ? [_errors] : [];
  });

  const isHasErrors = computed<boolean>(() => errorsToShow.value.length !== 0);

  return { errorsToShow, isHasErrors };
};

export { type FieldErrors, useFieldErrors };
